import React from 'react'
import Pagenation from '../../../GlobalComponents/User/Pagenation'
import CustomTextField from '../../../../../customComponents/CustomTextField'
import { withSponserCommission } from './HOCs/withSponserCommission'
import SponserCommissionTable from './SponserCommissionTable'
import MobileSponserComm from '../../../../Mobile/User/MobilePages/MobileEarnings/MobileAurCommission/MobileSponserComm'

const SponerCommission = ({
	sponserCommissionsData,
	totalItems,
	itemsPerPage,
	currentPage,
	searchTerm,
	startDate,
	endDate,
	handleSearch,
	handleDateChange,
	handleItemsPerPageChange,
	handlePageChange,
	handleSubmit,
	handleDeskDateChange,
}) => {
	return (
		<>
			<div className='main-width display mt-3'>
				<div className='row d-flex w-auto justify-content-center'>
					<div className='col-lg-12'>
						<div className='card w-98 card-body'>
							<h2 className='source-serif-4 text-normal text-dark'>
								<i className='ri-money-rupee-circle-fill class-name mx-md-2 text-success' aria-hidden='true'></i>
								Sponsor Commission
							</h2>

							<>
								<div className='row align-items-center mb-2 container-fluid mt-4'>
									<div className='col-lg-6'>
										<div className='d-flex gap-4'>
											<div>
												<div className='input-group input-group-outline' aria-label='Default select example'>
													<select
														className='dataTable-selector border-radius-lg'
														id='exampleFormControlSelect1'
														value={itemsPerPage}
														onChange={handleItemsPerPageChange}
													>
														<option value={10}>50</option>
														<option value={100}>100</option>
														<option value={200}>200</option>
														<option value={300}>300</option>
														<option value={400}>400</option>
													</select>
												</div>
											</div>
											<div>
												<div className='input-group input-group-outline w-100' aria-label='Default select example'>
													<input
														className='form-control datepicker'
														placeholder='Start Date'
														type='date'
														name='startDate'
														value={startDate}
														onChange={handleDeskDateChange}
													/>
												</div>
											</div>
											<div>
												<div className='input-group input-group-outline w-100' aria-label='Default select example'>
													<input
														className='form-control datepicker'
														placeholder='End Date'
														type='date'
														name='endDate'
														value={endDate}
														onChange={handleDeskDateChange}
													/>
												</div>
											</div>
											<div>
												<button type='button' className='btn btn-md text-black btn-yellow' onClick={handleSubmit}>
													Submit
												</button>
											</div>
										</div>
									</div>
									<div className='col-lg-6 '>
										<div className='d-flex justify-content-end text-end'>
											<div className='input-group input-group-outline w-30'>
												<CustomTextField
													type='text'
													className='form-control'
													placeholder='Search....'
													value={searchTerm}
													onChange={handleSearch}
												/>
											</div>
										</div>
									</div>
								</div>
								<SponserCommissionTable sponserCommissionsData={sponserCommissionsData} />
								<Pagenation
									totalItems={totalItems}
									itemsPerPage={itemsPerPage}
									currentPage={currentPage}
									onPageChange={handlePageChange}
								/>
							</>
						</div>
					</div>
				</div>
			</div>
			<div className='display-full'>
				<MobileSponserComm
					sponserCommissionsData={sponserCommissionsData}
					totalItems={totalItems}
					itemsPerPage={itemsPerPage}
					currentPage={currentPage}
					searchTerm={searchTerm}
					startDate={startDate}
					endDate={endDate}
					handleSearch={handleSearch}
					handleDateChange={handleDateChange}
					handleItemsPerPageChange={handleItemsPerPageChange}
					handlePageChange={handlePageChange}
					handleSubmit={handleSubmit}
				/>
			</div>
		</>
	)
}

export default withSponserCommission(SponerCommission)
